import React, {useState,useRef,forwardRef,useImperativeHandle, useEffect} from 'react';
import {useSelector, useDispatch,shallowEqual} from "react-redux";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import Radio from '@mui/material/Radio';
import Checkbox from '@mui/material/Checkbox';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { loginActions } from '@redux/actionCreators/UserActions';
import AlertBox, {alertTypes} from "@common/AlertBox"
import TOTPSetup from './TOTPSetup';
import { MFA_METHODS,TOTP, DEFAULT_PREF,MFA_PREF} from '@components/common/Login/constants';
import { SHOW_GLOBAL_TOAST } from '@utils/Events/constants';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
const SX = {
    title: {
        textAlign: 'center',
        fontWeight: 700,
        p: 2.5
    },
}
const mfaSx = {
  width: "calc(100% - 12px)",
  padding: '24px',
  //boxShadow: '8px 16px 48px 0 rgba(0, 0, 0, 0.1)',
  borderRadius: '4px',
  backgroundColor: '#fff',
  '& .error-msg':{
    padding:'6px 12px',
    my:1
  },
  '& h4': {
    fontFamily: 'Nunito Sans',
    fontSize: 19,
    fontWeight: 700,
   },
   '& .heading':{
        fontFamily: 'Nunito Sans',
        fontWeight:600,
        fontSize:16,
        '&.h4':{
            fontSize: 18,
            fontWeight: 700,
        }
   },
   '& .info':{
        display:'block',
        fontWeight:400,
        fontSize:14
   },
   '& .config-link':{
        float:'right',
        color:'#006ce0',
        fontSize:14
   },
    '& .MuiRadio-root':{
        padding:'0 8px'
    },
  '& .mfa-settings':{
    mt:1,
    flexWrap:'nowrap',
    '& .mfa-item':{
        margin:'6px',
        border:'1px solid #8c8c94',
        borderRadius:2,
        padding:'8px 12px',
        '&.active-true':{
            borderColor:'#006ce0',
            backgroundColor:'#f0fbff'
        }
    }
  },
  '& .mfa-methods':{
    //marginTop:1,
    '& .mfa-method':{
        py:0.5,
        '& .info':{
            pl:'28px'
        },
        '&.config-true':{
            '& .MuiFormControlLabel-root,.MuiFormControlLabel-label':{
                width:'100%'
            }
        }
    },
    '& .MuiCheckbox-root':{
        padding:'0 8px'
    },
    "& .mfa-pref":{
        marginTop:1,
        padding:1.5,
        backgroundColor:'#d1cccc'
    }
  },
  '& .button-grp':{
    mt:1,
    display:'flex',
    justifyContent:'flex-end'
  }
}
const INIT_STATE = {mfa:false,totpSetup:false,mfaSetupPending:true,enabled:[],saved:{enabled:[]},preferred:DEFAULT_PREF,errors:{}};
const MFAConfig = forwardRef(({sx={},configurable=true,standAlone=true,popup=false,savedPref,email,mfaRequired},ref)=>{
    const dispatch = useDispatch();
    const dataRef = useRef(INIT_STATE)
    const [state,setState] = useState(INIT_STATE);
    const updateState=(v,reset=false)=>setState(pv=>{
            const st = {...(reset?INIT_STATE:pv),...v};
            dataRef.current = st;
            return st;
    })
    const loadMFASettings = async (pv={})=>{
        const {enabled,preferred} = savedPref || (await loginActions.fetchMFAPreference());
        const saved = {enabled:(enabled || []),preferred:(preferred || DEFAULT_PREF),mfa:!!enabled?.length};
        console.log('saved pref',saved,enabled,preferred);
        updateState({...pv,...saved,saved,mfaSetupPending:!saved.mfa,errors:{}},true);
    }
    const validate = ()=>{
        const {mfa,enabled,totpSetup,saved} = dataRef.current;
        const errors = {};
        if((mfa || mfaRequired) && !enabled.length){
            errors.enabled = "Two-factor authentication is required";
        }
        else if(!totpSetup && enabled.includes(TOTP) && !saved.enabled.includes(TOTP)){
            errors.totpSetup = {save:true,totpSetup:true};
            //showTOTPSetup();
        }
        updateState({errors});
        return !Object.keys(errors).length
    }
    const postSetUp = (opt={})=>{
        const {save,...other} = opt;
        save && saveMFA(null,{skipValidation:true,...other});
        !save && updateState({...other,errors:{}});
    }
    const showSetup = (e,{key})=>{
        e.stopPropagation();
        e.preventDefault();
        updateState({errors:{[key]:{[key]:true}}});
    }
    const changedValues = ()=>{
        const {mfa,enabled,preferred,saved} = dataRef.current;
        const pref = (v)=> enabled.length>1? v == preferred?'PREFERRED':preferred == DEFAULT_PREF?preferred:'ENABLED':enabled.length?"ENABLED":"DISABLED";
        const preferredAlt = enabled.length>1?preferred == DEFAULT_PREF?null:preferred:enabled[0];
        const mfaPref = (mfa?enabled:saved.enabled).reduce((m,v)=>{
            m[v.toLowerCase()] = pref(v);
            return m;
        },{});
        return {mfa,enabled,preferred,mfaPref,preferredAlt}
    }
    const saveMFA = async(e,{skipValidation=false,...stateValue}={})=>{
        if(skipValidation || validate()){
            const {mfaPref,enabled} = changedValues()
            try{
                console.log(mfaPref,enabled);
                await dispatch(loginActions.updateMFAPreference(mfaPref));
                mfaRequired && enabled.length && (await dispatch(loginActions.setUserAttributes({mfaSetupPending:false})));
                loadMFASettings(stateValue);
                _app.events.trigger(SHOW_GLOBAL_TOAST,{type:alertTypes.SUCCESS,message:"MFA settings has been updated successfully."});
            }
            catch(error){
                console.log('error',error);
                updateState({errors:{common:error.message}});
            }
            
        }
    }
    useEffect(()=>{
        loadMFASettings();
    },[savedPref])
    
    useImperativeHandle(ref, () => {
        return {
            validate,
            changedValues
        };
    }, []);
    const onMfaChange = (event) => {
        let c = {mfa:event.target.value == "true"};
        !c.mfa && (c.enabled = []);
        c.mfa == state.saved.mfa && (c = {...state.saved});
        updateState({...c});
    };
    const onMfaMethodChange = (event,value) => {
        const enabled = [...state.enabled];
        event.target.checked?enabled.push(value):enabled.remove(value);
        updateState({enabled,mfa:!!enabled.length});
    }; 
    const onMfaPrefChange = (event) => {
        updateState({preferred:event.target.value});
    };
    const hasChange = ()=> {
        const {saved, ...unsaved} = state;
        return Object.keys(saved).some(k=>!deepEqual(saved[k],unsaved[k]));
    }
    return <EnforceMfa popup={!!popup} mfaSetupPending={state.mfaSetupPending}>
        <Box className="mfa-config" sx={{ ...mfaSx, ...sx, ...popup && { width: 'unset' } }}>
            {/* <Typography variant="h4">MFA Settings</Typography> */}
            <Box>
                {/*<AlertBox message={state.errors.common}  className="error-msg"/>
                  <RadioGroup row className='mfa-settings' value={state.mfa} onChange={onMfaChange}>
                  <Box className={`mfa-item active-${state.mfa}`}>
                    <FormControlLabel value={true} control={<Radio />} label={<><span className='heading'>Enable MFA</span></>} />
                    <span className='info'>User can sign in with MFA</span>
                  </Box>
                  <Box className={`mfa-item active-${!state.mfa}`}>
                    <FormControlLabel value={false} control={<Radio />} label={<><span  className='heading'>Disable MFA</span></>} />
                    <span className='info'>User signs in with username and password only</span>
                  </Box>
                </RadioGroup> */}
                {true && <Box className="mfa-methods">
                    <Box>
                        <label className='heading h4'>Two-factor methods</label>
                        <span className='info'>Two-factor authentication adds an additional layer of security to your account by requiring more than just a password to sign in.</span>
                    </Box>
                    <AlertBox message={state.errors.enabled || state.errors.common} className="error-msg" />
                    <Box className="mfa-method-options">
                        {MFA_METHODS.map(mfaMethod =>
                            <Box className={`mfa-method config-${!!mfaMethod.installation && configurable && state.saved.enabled.includes(mfaMethod.value)}`} key={mfaMethod.value}>
                                <FormControlLabel control={<Checkbox disabled={!state.saved.enabled.includes(mfaMethod.value) && !!mfaMethod.installation && !configurable} checked={state.enabled.includes(mfaMethod.value)} onChange={(e) => onMfaMethodChange(e, mfaMethod.value)} />} label={<><span className='heading'>{mfaMethod.name}</span>{configurable && mfaMethod.installation && state.saved.enabled.includes(mfaMethod.value) && <span className='config-link' onClick={(e) => showSetup(e, mfaMethod.installation)}>{mfaMethod.installation.title}</span>}</>} />
                                <span className='info'>{mfaMethod.info}</span>
                            </Box>)}
                    </Box>
                    {state.enabled.length > 1 && <Box className="mfa-pref">
                        <Box>
                            <label className='heading'>Preferred MFA method</label>
                            <span className='info'>If you don't set a preferred method, you will have to choose an available method during sign-in.</span>
                        </Box>
                        <RadioGroup row value={state.preferred} onChange={onMfaPrefChange}>
                            {MFA_PREF.map(pref => <Box className={`mfa-item active-${state.preferred == pref.value}`}>
                                <FormControlLabel value={pref.value} control={<Radio />} label={<><span className='heading'>{pref.name}</span></>} />
                            </Box>)}
                        </RadioGroup></Box>}
                    {configurable && state.errors.totpSetup && <TOTPSetup email={email} opts={state.errors.totpSetup} postVerify={postSetUp} onCancel={() => updateState({ errors: {} })} />}
                </Box>}
            </Box>
            {standAlone && <Box className="button-grp"><Button variant='contained' disabled={!hasChange()} size='small' onClick={saveMFA}>Save</Button></Box>}
        </Box>
    </EnforceMfa>
});
const EnforceMfa = ({popup,mfaSetupPending,children})=>{
    if(!popup){
        return children
    }
    return mfaSetupPending?<Dialog
            sx={{ zIndex: 1500, '& .MuiDialog-paper': { width: '600px' } }}
            open
            className={`confirm-dialog`}
        >
            <DialogTitle sx={SX.title}>
                Two-factor authentication (2FA) will be required on next login — set it up now
            </DialogTitle>    
            <DialogContent>
                <Box>
                    {children}
                </Box>
            </DialogContent>
            {/* <DialogActions sx={{ px: 2, py: 3, justifyContent: 'center' }}>
                <Button autoFocus onClick={onClose} variant="outlined">
                    Cancel
                </Button>
                <Button color="primary" variant="contained" onClick={onSave}>Save</Button>
            </DialogActions> */}
        </Dialog>:null
}
export default MFAConfig;